import React from "react";
import { Tooltip } from "../../CommonUI/tooltip";
import CancelBtn from "../../CustomButtons/CancelBtn/CancelBtn";
import DeleteButton from "./DeleteButton/DeleteButton";
import MarkAsReconciledButton from "./MarkAsReconciledButton/MarkAsReconciledButton";
import ArchiveButton from "./ArchiveButton/ArchiveButton";
import ReportMistakeButton from "./ReportMistakeButton/ReportMistakeButton";
import ExportButton from "./ExportButton/ExportButton";
import UnarchiveButton from "./UnarchiveButton/UnarchiveButton";
import RequestPaperWorkModal from "../RequestPaperWorkModal/RequestPaperWorkModal";
import { useState } from "react";
import { SupplierStatementArchiveRecord } from "../../../Types/SupplierStatementArchive";

interface StatementHeaderProps {
  onClose: () => void;
  mistakeReported: boolean;
  onMistakeReportedChange: (reported: boolean) => void;
  invoiceId: number | null;
  onReconciled: () => void;
  onBeforeAction: (action: () => void) => void;
  archiveRecord?: SupplierStatementArchiveRecord;
  navigation?: {
    currentIndex: number;
    totalCount: number;
    onPrevious: () => void;
    onNext: () => boolean;
  };
}

const StatementHeader: React.FC<StatementHeaderProps> = ({
  onClose,
  mistakeReported,
  onMistakeReportedChange,
  invoiceId,
  onReconciled,
  onBeforeAction,
  archiveRecord,
  navigation,
}) => {
  const [showPaperWork, setShowPaperWork] = useState(false);

  return (
    <>
      <div className="statementView-header">

        <div className="statementView-header-main-row">
          <div className="statementView-header-actions">
            <DeleteButton
              invoiceIds={invoiceId !== null ? [invoiceId] : []}
              onSuccess={onReconciled}
              onBeforeAction={onBeforeAction}
            />
            {!archiveRecord && !mistakeReported && (
              <>
                <MarkAsReconciledButton
                  invoiceId={invoiceId}
                  onSuccess={onReconciled}
                  onBeforeAction={onBeforeAction}
                />
                <button className="sv-action-btn sv-btn-paperwork" onClick={() => setShowPaperWork(true)}>
                  <span className="sv-btn-text">Request paper work</span>
                </button>
              </>
            )}
            {archiveRecord ? (
              <UnarchiveButton
                record={archiveRecord}
                onSuccess={onReconciled}
                onBeforeAction={onBeforeAction}
              />
            ) : (
              <ArchiveButton
                invoiceId={invoiceId}
                onSuccess={onReconciled}
                onBeforeAction={onBeforeAction}
              />
            )}
            <ReportMistakeButton
              isReported={mistakeReported}
              onReportedChange={onMistakeReportedChange}
            />
            <ExportButton />
          </div>
          <div className="statementView-header-title">
            Statement View
            {navigation && ` (${navigation.currentIndex + 1} of ${navigation.totalCount})`}
          </div>

          <div className="statementView-header-right">
            {navigation && (
              <>
                <button
                  type="button"
                  className="sv-nav-btn"
                  style={{ backgroundColor: navigation.currentIndex === 0 ? "#cccccc" : "var(--color-brand)" }}
                  disabled={navigation.currentIndex === 0}
                  onClick={() => onBeforeAction(() => navigation.onPrevious())}
                >
                  Previous
                </button>
                <button
                  type="button"
                  className="sv-nav-btn"
                  style={{backgroundColor:navigation.currentIndex >= navigation.totalCount - 1 ? "#cccccc" : "var(--color-brand)" }}
                  disabled={navigation.currentIndex >= navigation.totalCount - 1}
                  onClick={() => onBeforeAction(() => navigation.onNext())}
                >
                  Next
                </button>
              </>
            )}
            <Tooltip title="Close Statement View" position="left">
              <div className="statementView-header-close" onClick={() => onBeforeAction(onClose)}>
                <CancelBtn />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>

      <RequestPaperWorkModal isOpen={showPaperWork} onClose={() => setShowPaperWork(false)} />
    </>
  );
};

export default StatementHeader;
